module.exports = __webpack_public_path__ + "static/media/Kimberly P.b0c752ee.png";